import React from 'react'
import { Select } from 'antd'

const AgreementStateSelect = props => (
  <Select
    style={{ width: '100%' }}
    allowClear
    placeholder="Seleziona lo stato"
    onChange={props.onChange}
    value={props.value}
    defaultValue={props.defaultValue}>
    {props.states.map(s => (
      <Select.Option key={s.key} value={s.key}>
        {s.label}
      </Select.Option>
    ))}
  </Select>
)
export default AgreementStateSelect



// WEBPACK FOOTER //
// ./src/components/AgreementStateSelect/index.js